import styled, { css } from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';

const colorSelector = ({
  theme,
  color
}) => theme.base[color];

export const HeadingBase = css`
  font-family: ${({
  theme
}) => theme.fonts.primary};
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: ${props => props.textAlign};
  text-transform: ${props => props.textTransform};
`;
export const one = css`
  font-size: 1.625rem;
  font-weight: 900;
  color: ${colorSelector};

  ${breakpoints.md} {
    font-size: 2.75rem;
  }
`;
export const two = css`
  font-size: 1.625rem;
  font-weight: 700;
  color: ${colorSelector};

  ${breakpoints.md} {
    font-size: 2.25rem;
  }
`;
export const three = css`
  font-size: 1.625rem;
  font-weight: 700;
  color: ${colorSelector};

  ${breakpoints.md} {
    font-size: 2rem;
  }
`;
export const four = css`
  font-size: 1.625rem;
  font-weight: 700;
  color: ${colorSelector};

  ${breakpoints.md} {
    font-size: 1.75rem;
  }
`;
export const five = css`
  font-size: 1.125rem;
  font-weight: 700;
  color: ${colorSelector};

  ${breakpoints.md} {
    font-size: 1.375rem;
  }
`;
export const six = css`
  font-size: 1.25rem;
  font-weight: 700;
`;
export const brand = css`
  font-size: 1.625rem;
  font-weight: 900;
  line-height: 1.625rem;
  color: ${colorSelector};

  ${breakpoints.md} {
    font-size: 2.5rem;
    line-height: 2.5rem;
  }
`;
export const Copyright = styled.span`
  display: inline-block;
  font-size: 1.25rem;
  color: ${({
  theme
}) => theme.secondary.light};
  letter-spacing: 0;
  line-height: 2rem;
`;